// extracted by mini-css-extract-plugin
export var center = "_4i-2";
export var clickableRow = "_4i-5";
export var expandedRow = "_4i-7";
export var hoverable = "_4i-4";
export var left = "_4i-1";
export var right = "_4i-3";
export var row = "_4i-0";
export var selectedRow = "_4i-6";
export var summaryRow = "_4i-8";